var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3464L11.9981 15.872C12.6289 16.2704 13.407 15.6783 13.2396 14.928L12.1783 10.1672L15.7114 6.96363C16.2681 6.45918 15.9704 5.50164 15.2366 5.43679L10.586 5.02413L8.76679 0.531194C8.47955 -0.177065 7.52045 -0.177065 7.23321 0.531194L5.41399 5.02413L0.763362 5.43679C0.0295607 5.50164 -0.268144 6.45918 0.288644 6.96363L3.82167 10.1672L2.7604 14.928C2.59304 15.6783 3.37109 16.2704 4.00191 15.872L8 13.3464Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.7e8946277d492496f1b0dbe5983998c0.svg";
export { ForwardRef as ReactComponent };